import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { api } from "../../services/api/api.service";
import { API_SEND_MESSAGE } from "../../services/api/api.urls";
//import { COMPANY_ABBR } from "../../common/constants/company";
//import { toastr } from "react-redux-toastr";
import { IEmail } from "../../shared/interfaces/IEmail";

const initialState: IEmail = {
    name: '',
    email: '',
    subject: '',
    body: ''
}

export const sendEmail = createAsyncThunk<void, IEmail, { rejectValue: string }>(
    'shared/sendEmail',
    async (payload, { rejectWithValue }) => {
        try {
            await api.post(API_SEND_MESSAGE, payload);
            //return;
            //const { data } = await api.post(API_SEND_MESSAGE, payload);

            //if (!data.isOk) {
            //    toastr.error(COMPANY_ABBR, `${data.message}`)
            //}
            //if (data.isOk) {
            //    toastr.success(COMPANY_ABBR, `${data.message}`)
            //    window.history.back();
            //}
            //return;

        } catch (error) {
            if (error instanceof Error) {
                return rejectWithValue(error.message);
                //return rejectWithValue(data);
            }
            //if(error instanceof AxiosError) {
            //    return rejectWithValue(error.response?.data as string);
            //}
            return rejectWithValue('An unknown error occurred');
        }
    }
);

export const SharedSlice = createSlice({
    name: 'shared',
    reducers: {
    },
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(sendEmail.pending, (state: IEmail) => {
                //state.loader = true;
            })
            .addCase(sendEmail.fulfilled, (state: IEmail, action) => {
                //state.loader = false;
                window.history.back();
            })
            .addCase(sendEmail.rejected, (state: IEmail, action) => {
                //state.loader = false;
            })
    }
})

export default SharedSlice.reducer;